import { PencilBrush, Point } from 'fabric';

// Rough brush: adds random positional jitter for a dry, gritty texture
export class RoughBrush extends PencilBrush {
  onMouseMove(pointer, options) {
    const scatter = Math.max(2, (this.width || 4) * 0.5);
    super.onMouseMove(
      new Point(
        pointer.x + (Math.random() - 0.5) * scatter * 2,
        pointer.y + (Math.random() - 0.5) * scatter * 2,
      ),
      options
    );
  }
}
